<template>
    <div class="data-steps">
        <div class="data-steps__title">
            <h3>{{ $t('connect.step3Title') }}</h3>
            <div class="text-description">{{ $t('connect.step3Description') }}</div>
        </div>
        <el-row :guter="20">
            <el-col :span="12" :xs="24" class="mb-3 mb-sm-0">
                <InputSearch v-model="q" @keyup.native="onSearchData" @keydown.native="onSearchData" :placeholder="$t('connect.step3Title')"> </InputSearch>
            </el-col>
            <el-col :span="12" :xs="24">
                <div class="data-steps__adds">
                    <a class="icon-grid" :class="{ 'icon-grid__active': layoutStep === 1 }" href="javascript:void(0)" @click="setLayout(1)">
                        <i class="fa fa-list"></i>
                    </a>
                    <a class="icon-grid" :class="{ 'icon-grid__active': layoutStep === 2 }" href="javascript:void(0)" @click="setLayout(2)">
                        <i class="fas fa-th"></i>
                    </a>
                </div>
            </el-col>
        </el-row>
        <box-loading v-if="isLoading"></box-loading>
        <div class="py-2" v-else>
            <!--START:list Workspace-->
            <div class="list-workspace" v-if="layoutStep === 2">
                <div
                    v-for="(item, index) in options"
                    :key="index + 'box'"
                    class="card ribbon-vertical-left-wrapper cursor-pointer group"
                    @click="emitAppData(item)"
                    :class="{ active: dataView['view_id'] === item.id, disabled: !['LIST', 'CALENDAR'].includes(item.type) }"
                >
                    <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataView['view_id'] === item.id">
                        <i class="fa fa-star"></i>
                    </div>
                    <div class="job-search">
                        <div class="card-body" :class="{ 'disabled bg-dark-light': !['LIST', 'CALENDAR'].includes(item.type) }">
                            <div class="media">
                                <icon-box-view v-show="dataView['view_id'] !== item.id"></icon-box-view>
                                <div class="media-body pl-3">
                                    <h6 class="f-w-600">
                                        <a href="javascript:void(0)" class="text-name-space font-weight-bold hover-text" @click="showKintoneView(item.id)" style="-webkit-line-clamp: 1">
                                            {{ item.id ? item.name : $t('apps.viewDefault') }}
                                        </a>
                                    </h6>
                                    <div>
                                        {{ item.type }}
                                    </div>
                                </div>
                            </div>
                            <div v-html="item.description" class="overflow_text"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="table-sm table-kb">
                <table class="table table-hover table-common">
                    <thead>
                        <tr>
                            <th></th>
                            <th>No.</th>
                            <th>{{ $t('apps.viewName') }}</th>
                            <th>{{ $t('apps.viewType') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="(item, index) in options"
                            :key="index + 'row'"
                            :class="{ active: dataView['view_id'] === item.id, disabled: !['LIST', 'CALENDAR'].includes(item.type) }"
                            @click="emitAppData(item)"
                            class="row-workspace"
                        >
                            <td>
                                <div class="ribbon ribbon-bookmark ribbon-vertical-left ribbon-secondary" v-if="dataView['view_id'] === item.id">
                                    <i class="fa fa-star"></i>
                                </div>
                            </td>
                            <td class="w-10" :data-title="'No.'">{{ index + 1 }}</td>
                            <td :data-title="$t('apps.viewName')">
                                <h6 @click="showKintoneView(item.id)" class="text-name text-hover">
                                    {{ item.id ? item.name : $t('apps.viewDefault') }}
                                </h6>
                            </td>
                            <td :data-title="$t('apps.viewType')" class="w-20 text-left">
                                {{ item.type }}
                            </td>
                        </tr>
                        <tr v-if="options.length === 0">
                            <td :colspan="5" class="text-center">
                                <el-empty :description="$t('app.noDataSetting')"></el-empty>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <!--END:list Workspace-->
            <!--START:Box Filter-->
            <div class="mt-4">
                <h3>{{ $t('filter.filterList') }}</h3>
                <div class="box-filter">
                    <div class="box-filter__label">{{ $t('filter.filterTitle') }}</div>
                    <div class="box-filter__items">
                        <div class="d-flex flex-row align-items-center padding-10 text-bold">
                            <div class="mr-3 w-25">{{ $t('filter.content1') }}</div>
                            <div class="mr-3 w-25">{{ $t('filter.content2') }}</div>
                            <div class="w-40">{{ $t('filter.content3') }}</div>
                        </div>
                        <template v-for="(elmFilter, indexFilter) in filterContents">
                            <div class="box-filter__item" :key="indexFilter">
                                <SelectCustom classes="mr-3 w-25" v-model="elmFilter.field" @change="onChangeTypeFilter(elmFilter.field, indexFilter)">
                                    <template #options>
                                        <el-option v-for="(item, index) in listFilters" :key="index + 'field'" :label="item.label" :value="item.code">
                                            {{ item.label }}
                                        </el-option>
                                    </template>
                                </SelectCustom>
                                <SelectCustom classes="mr-3 w-25" v-model="elmFilter.type" v-if="elmFilter.field !== TYPE_ALL_RECORD">
                                    <template #options>
                                        <el-option v-for="(item, index) in elmFilter.listTypeConditions" :key="index + 'condition'" :label="item.label" :value="item.value">
                                            {{ item.label }}
                                        </el-option>
                                    </template>
                                </SelectCustom>
                                <div class="w-40 input-options" v-if="elmFilter.field !== TYPE_ALL_RECORD">
                                    <SelectCustom classes="w-100" v-if="['in', 'not in'].includes(elmFilter.type)" v-model="elmFilter.value" allow-create is-multi>
                                        <template #options>
                                            <el-option v-for="(item, indexC) in elmFilter.options" :value="item.value" :label="item.label" :key="indexC">
                                                {{ item.label }}
                                            </el-option>
                                        </template>
                                    </SelectCustom>
                                    <InputText v-if="!['in', 'not in'].includes(elmFilter.type) && !elmFilter.typeDate" v-model="elmFilter.value"></InputText>
                                    <div v-if="elmFilter && elmFilter.typeDate">
                                        <el-date-picker v-if="elmFilter.typeField === TYPE_DATE" format="yyyy/MM/dd" value-format="yyyy-MM-ddTHH:mm:ssZ" v-model="elmFilter.value"> </el-date-picker>
                                        <el-date-picker
                                            v-if="elmFilter.typeField === TYPE_DATE_TIME"
                                            format="yyyy/MM/dd HH:mm"
                                            type="datetime"
                                            value-format="yyyy-MM-ddTHH:mm:ssZ"
                                            v-model="elmFilter.value"
                                        >
                                        </el-date-picker>
                                        <el-time-select
                                            :picker-options="{
                                                start: '00:00',
                                                step: '00:30',
                                                end: '23:30'
                                            }"
                                            v-if="elmFilter.typeField === TYPE_TIME"
                                            v-model="elmFilter.value"
                                        >
                                        </el-time-select>
                                    </div>
                                </div>
                                <i class="el-icon-remove icon-remote" @click="onDeleteFieldFilter(indexFilter)" v-if="elmFilter.field !== TYPE_ALL_RECORD"></i>
                            </div>
                        </template>
                        <div class="box-filter__item-add" @click="onAddFilterField">
                            <el-icon class="el-icon-circle-plus"></el-icon>
                        </div>
                        <div class="box-filter__item-condition">
                            <RadioList v-model="conditionType" :data-list="listTypeFilters"></RadioList>
                        </div>
                        <div class="box-filter__item-clear">
                            <Button @click="onDeleteAllFilter" type="primary">
                                {{ $t('filter.buttonClearAll') }}
                            </Button>
                        </div>
                        <div class="box-filter__item-clear mt-5">
                            <div class="text-note-button" v-if="isAddCondition">
                                <span class="font-weight-bold mr-3">
                                    {{ $t('filter.descriptionButton1') }}
                                </span>
                                <span>{{ $t('filter.descriptionButton2') }}</span>
                            </div>
                            <Button @click="onSearchDataView" type="primary" classes="w-100 py-2">
                                <el-icon class="el-icon-search mr-2"></el-icon>
                                {{ $t('button.search') }}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <!--END:Box Filter-->
            <ArrayFieldListView :list-field="dataPreviews.fields" :array-field-view.sync="dataView.arrayFieldView"></ArrayFieldListView>
            <FieldDisplayLayout :list-field="dataPreviews.fields" :field-display-layout.sync="dataView.fieldDisplayLayout"></FieldDisplayLayout>
            <ArrayFieldDisabled :list-field="dataPreviews.fields" :array-field-disabled.sync="dataView.arrayFieldDisabled"></ArrayFieldDisabled>
            <ListPreview :data-previews="dataPreviews"></ListPreview>
        </div>
        <div class="card-footer footer-buttons">
            <Button @click="handlePrevStep" classes="btn-sm mr-3" type="warning"> <i class="el-icon-back"></i>{{ $t('connect.prevStep') }} </Button>
            <Button @click="handleNextStep" :disabled="!dataView.view_name || listFilters.length === 0" classes="btn-sm" type="primary">
                {{ $t('connect.nextStep') }}<i class="el-icon-right"></i>
            </Button>
        </div>
    </div>
</template>

<script>
import Button from '@/components/partials/Button';
import { mapState } from 'vuex';
import IconBoxView from '@/components/format/iconBoxView';
import InputSearch from '@/components/partials/customs/InputSearch';
import BoxLoading from '@/components/partials/BoxLoading';
import SelectCustom from '@/components/partials/customs/SelectCustom';
import ArrayFieldListView from './arrayFieldListView';
import FieldDisplayLayout from './fieldDisplayLayout.vue';
import ArrayFieldDisabled from './arrayFieldDisabled';
import ListPreview from './listPreview';
import { indexKintoneView } from './index.js';
import InputText from '@/components/partials/customs/InputText';
import RadioList from '@/components/partials/RadioList';
import {
    TYPE_UPDATE_TIME,
    TYPE_MODIFIER,
    TYPE_DATE,
    TYPE_CREATOR,
    TYPE_CHECK_BOX,
    TYPE_DROPDOWN,
    TYPE_RECORD_NUMBER,
    TYPE_TEXT,
    TYPE_NUMBER,
    TYPE_CREATED_TIME,
    TYPE_TEXTS,
    TYPE_LINK,
    TYPE_RICK_TEXT,
    TYPE_TIME,
    TYPE_FILE,
    TYPE_RADIO_BUTTON,
    TYPE_SUB_TABLE,
    TYPE_DATE_TIME,
    TYPE_REFERENCE_TABLE,
} from '@/config/constants.js';
export default {
    name: 'step3',
    props: ['data'],
    components: {
        RadioList,
        BoxLoading,
        IconBoxView,
        Button,
        InputSearch,
        SelectCustom,
        InputText,
        ArrayFieldListView,
        ArrayFieldDisabled,
        FieldDisplayLayout,
        ListPreview
    },
    data() {
        return {
            TYPE_SUB_TABLE,
            TYPE_DATE,
            TYPE_DATE_TIME,
            TYPE_TIME,
            TYPE_RICK_TEXT,
            isLoading: false,
            layoutStep: parseInt(localStorage.getItem('layoutStep3')) || 2,
            q: '',
            listViews: [],
            dataView: this.data,
            options: [],
            conditionType: 1,
            listFilters: [],
            listAllFields: [],
            TYPE_ALL_RECORD: 'All_Record',
            optionsCreate: [],
            dataPreviews: [],
            filterContentDefault: {
                field: 'All_Record',
                type: '1',
                value: '',
                typeField: '',
                listTypeConditions: []
            },
            filterContents: [this.filterContentDefault],
            isAddCondition: false
        };
    },
    created() {
        let namePage = this.$route.name;
        if (namePage === 'editShare' || namePage === 'editDataLinkMulti') {
            if (this.dataView.arrayContentFilter && this.dataView.arrayContentFilter.length > 0) {
                this.filterContents = this.dataView.arrayContentFilter;
            } else {
                this.filterContents = [this.filterContentDefault];
            }
            this.conditionType = this.dataView.typeFilter === 'or' ? 2 : 1;
            this.onSearchDataView();
        } else {
            this.getAllFieldFilter();
            if (localStorage.getItem('arrayContentFilter')) {
                this.filterContents = JSON.parse(localStorage.getItem('arrayContentFilter'));
            } else {
                this.filterContents = [this.filterContentDefault];
            }
            this.conditionType = this.$ld.includes(this.dataView.dataFilter, ' or ') ? 2 : 1;
            this.onSearchDataView();
        }
    },
    computed: {
        ...mapState('auth', ['userInfo']),
        listTypeFilters() {
            return [
                { value: 1, label: this.$t('filter.allFilter') },
                { value: 2, label: this.$t('filter.anyFilter') }
            ];
        },
        listTypeText() {
            // Text and Link
            return [
                { value: '=', label: this.$t('filter.condition1') },
                { value: '!=', label: this.$t('filter.condition2') },
                { value: 'in', label: this.$t('filter.condition3') },
                { value: 'not in', label: this.$t('filter.condition4') },
                { value: 'like', label: this.$t('filter.condition5') },
                { value: 'not like', label: this.$t('filter.condition6') }
            ];
        },
        listTypeNumber() {
            // Number, Calculated, id, Record Number
            return [
                { value: '=', label: this.$t('filter.condition1') },
                { value: '!=', label: this.$t('filter.condition2') },
                { value: '<', label: this.$t('filter.condition8') },
                { value: '>', label: this.$t('filter.condition10') },
                { value: '>=', label: this.$t('filter.condition9') },
                { value: '<=', label: this.$t('filter.condition7') },
                { value: 'in', label: this.$t('filter.condition3') },
                { value: 'not in', label: this.$t('filter.condition4') }
            ];
        },
        listTypeDate() {
            // Date Time
            return [
                { value: '=', label: this.$t('filter.condition1') },
                { value: '!=', label: this.$t('filter.condition2') },
                { value: '<=', label: this.$t('filter.condition7') },
                { value: '<', label: this.$t('filter.condition8') },
                { value: '>=', label: this.$t('filter.condition9') },
                { value: '>', label: this.$t('filter.condition10') }
            ];
        },
        listTypeSelect() {
            // Updated_by, Created_by, Checkbox, RadioButton, Dropdown, Multi Choice, User Selection, Department Selection
            return [
                { value: 'in', label: this.$t('filter.condition3') },
                { value: 'not in', label: this.$t('filter.condition4') }
            ];
        },
        listTypeTextArea() {
            // Textarea, RickText, Attachment
            return [
                { value: 'like', label: this.$t('filter.condition5') },
                { value: 'not like', label: this.$t('filter.condition6') }
            ];
        },

        listAllTypes() {
            return [
                { value: '=', label: this.$t('filter.condition1') },
                { value: '!=', label: this.$t('filter.condition2') },
                { value: 'in', label: this.$t('filter.condition3') },
                { value: 'not in', label: this.$t('filter.condition4') },
                { value: 'like', label: this.$t('filter.condition5') },
                { value: 'not like', label: this.$t('filter.condition6') },
                { value: '<=', label: this.$t('filter.condition7') },
                { value: '<', label: this.$t('filter.condition8') },
                { value: '>=', label: this.$t('filter.condition9') },
                { value: '>', label: this.$t('filter.condition10') }
            ];
        }
    },
    watch: {
        dataView: {
            deep: true,
            handler: function () {
                this.$emit('update:data', this.dataView);
            }
        },
        dataPreviews: {
            deep: true,
            handler(val) {
                this.dataView.code_kintone = [];
                this.dataView.information_view = {};
                for (let key of this.$ld.keys(val.fields)) {
                    this.dataView.information_view[key] = [key, val.fields[key].type];
                    this.dataView.code_kintone.push(key);
                }
            }
        },
        filterContents: {
            deep: true,
            handler(val) {
                if (val) {
                    let dataFilter = this.dataView.dataFilter || '';
                    let dataCheck = this.onGetQueryString();
                    if (dataFilter !== dataCheck) {
                        this.isAddCondition = true;
                    }
                } else {
                    this.isAddCondition = false;
                }
            }
        },
        conditionType(val) {
            let dataFilter = this.dataView.dataFilter || '';
            let type = this.$ld.includes(dataFilter, ' or ') ? 2 : 1;
            if (type !== val) {
                this.isAddCondition = true;
            } else {
                this.isAddCondition = false;
            }
        },
        listFilters: {
            deep: true,
            handler(val) {
                if (val) {
                    let arrayFilter = [];
                    this.listFilters.forEach((item) => {
                        if (item.type) {
                            arrayFilter.push(item);
                        }
                    });
                    localStorage.setItem('listFiltersStep4', JSON.stringify(arrayFilter));
                } else {
                    localStorage.setItem('listFiltersStep4', JSON.stringify([]));
                }
            }
        }
    },
    methods: {
        getFilterText() {
            let textResult = '';
            let { filterContents, listAllFields, conditionType } = this;
            let dataFilter = filterContents ? this.$ld.filter(filterContents, (elm) => elm.field !== this.TYPE_ALL_RECORD) : [];
            let typeFilter = conditionType === 1 ? 'and' : 'or';
            if (listAllFields) {
                if (dataFilter.length === 0) {
                    textResult = this.$t('filter.allRecord');
                } else {
                    this.$ld.map(dataFilter, (elm, index) => {
                        if (elm.field) {
                            textResult += listAllFields[elm.field] ? listAllFields[elm.field].label : '';
                            let typeIndex = this.$ld.findIndex(this.listAllTypes, (type) => type.value === elm.type);
                            if (typeIndex >= 0) {
                                textResult += ` ${this.listAllTypes[typeIndex].label} `;
                            }
                            if (elm.value && this.$ld.isArray(elm.value)) {
                                textResult += ` (${this.$ld.join(elm.value, ' , ')}) `;
                            } else {
                                textResult += ` ${elm.value} `;
                            }
                            if (index < dataFilter.length - 1) {
                                textResult += ` ${typeFilter} `;
                            }
                        }
                    });
                }
            }
            return textResult;
        },
        onSearchData() {
            if (this.isLoading) return;
            this.isLoading = true;
            setTimeout(() => {
                this.isLoading = false;
                this.options = this.listViews.filter((item) => {
                    return item.name.toLowerCase().indexOf(this.q.toLowerCase()) > -1;
                });
                this.dataPreviews = {};
            }, 200);
        },
        onChangeTypeFilter(field, indexField) {
            if (field) {
                let index = this.listFilters.findIndex((elm) => elm.code === field);
                if (index >= 0) {
                    let type = this.listFilters[index].type;
                    let listTypeResult = [];
                    this.filterContents[indexField].value = '';
                    this.filterContents[indexField].typeField = type;
                    this.filterContents[indexField].typeDate = false;
                    this.filterContents[indexField].options = [];
                    if (this.listAllFields[field] && this.listAllFields[field].options) {
                        Object.keys(this.listAllFields[field].options).map((key) => {
                            this.filterContents[indexField].options.push({
                                value: key,
                                label: key
                            });
                        });
                    }
                    switch (type) {
                        case TYPE_TEXT:
                            listTypeResult = this.listTypeText;
                            break;
                        case TYPE_TEXTS:
                            listTypeResult = this.listTypeText;
                            break;
                        case TYPE_FILE:
                            listTypeResult = this.listTypeText;
                            break;
                        case TYPE_LINK:
                            listTypeResult = this.listTypeText;
                            break;
                        case TYPE_DATE:
                            listTypeResult = this.listTypeDate;
                            this.filterContents[indexField].typeDate = true;
                            break;
                        case TYPE_TIME:
                            listTypeResult = this.listTypeDate;
                            this.filterContents[indexField].typeDate = true;
                            break;
                        case TYPE_DATE_TIME:
                            listTypeResult = this.listTypeDate;
                            this.filterContents[indexField].typeDate = true;
                            break;
                        case TYPE_UPDATE_TIME:
                            this.filterContents[indexField].typeDate = true;
                            listTypeResult = this.listTypeDate;
                            break;
                        case TYPE_CREATED_TIME:
                            this.filterContents[indexField].typeDate = true;
                            listTypeResult = this.listTypeDate;
                            break;
                        case TYPE_RECORD_NUMBER:
                            listTypeResult = this.listTypeNumber;
                            break;
                        case TYPE_NUMBER:
                            listTypeResult = this.listTypeNumber;
                            break;
                        case TYPE_CREATOR:
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            break;
                        case TYPE_DROPDOWN:
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            break;
                        case TYPE_RADIO_BUTTON:
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            break;
                        case TYPE_CHECK_BOX:
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            break;
                        case TYPE_MODIFIER:
                            listTypeResult = this.listTypeSelect;
                            this.filterContents[indexField].value = [];
                            break;
                        default:
                            listTypeResult = this.listTypeText;
                            break;
                    }
                    this.filterContents[indexField].listTypeConditions = listTypeResult;
                    if (listTypeResult && listTypeResult.length > 0) {
                        this.filterContents[indexField].type = listTypeResult[0].value;
                    }
                }
            }
        },
        onAddFilterField() {
            this.filterContents.push({
                field: '',
                type: '',
                value: '',
                typeField: ''
            });
        },
        onDeleteAllFilter() {
            this.$store.commit('noticeSystem/SET_CONFIRM', {
                type: `warning`,
                isShowConfirm: true,
                message: this.$t('filter.msgClearAll'),
                callback: () => {
                    this.filterContents = [this.filterContentDefault];
                }
            });
        },
        onDeleteFieldFilter(index) {
            if (index > 0) {
                this.filterContents.splice(index, 1);
            } else {
                if (this.filterContents.length === 1) {
                    this.filterContents = [this.filterContentDefault];
                } else {
                    this.filterContents.splice(index, 1);
                }
            }
        },

        handlePrevStep() {
            this.$emit('prevStep');
        },
        handleNextStep() {
            this.$emit('nextStep');
            let queryContents = this.filterContents.filter((elm) => elm.field && elm.field !== this.TYPE_ALL_RECORD);
            this.dataView.arrayContentFilter = queryContents ?? [];
            if (this.dataView && this.dataView.arrayContentFilter && this.dataView.arrayContentFilter.length > 0) {
                this.dataView.arrayContentFilter[0].query = this.getFilterText();
                this.dataView.dataFilter = this.onGetQueryString();
                localStorage.setItem('arrayContentFilter', JSON.stringify(this.dataView.arrayContentFilter));
            }
        },
        setLayout(type) {
            this.layoutStep = type;
            localStorage.setItem('layoutStep3', type);
        },
        getAllFieldFilter() {
            let successCallback = (response) => {
                let { data } = response.data;
                this.listFilters = data.views.field;
                let fieldNotShow = [TYPE_SUB_TABLE, TYPE_REFERENCE_TABLE, TYPE_FILE];
                this.listFilters = this.listFilters.filter((elm) => !fieldNotShow.includes(elm.type));
                this.listFilters.unshift({
                    label: this.$t('filter.allRecord'),
                    code: 'All_Record',
                    type: ''
                });
            };
            let errorCallback = () => {};

            let payload = {
                successCallback,
                errorCallback,
                appId: this.dataView.app_id,
                spaceUid: this.dataView.workspace_uid
            };
            if (payload.spaceUid) {
                this.$store.dispatch('connect/getAllFieldFilter', payload);
            }
        },

        getListViews(query = '') {
            this.dataView.dataFilter = query;
            if (this.isLoading) return;
            this.isLoading = true;
            let successCallback = (response) => {
                let { views } = response.data.data;
                this.listViews = views || [];
                let viewAll = views.filter((elm) => elm.id === null);
                if (viewAll && viewAll.length > 0) {
                    this.listAllFields = viewAll && viewAll[0] ? viewAll[0].fields : null;
                }
                let n = this.listViews.findIndex((x) => x.id === null);
                if (n >= 0) {
                    for (let item of this.listViews) {
                        if (item.type === 'CALENDAR' && !item.data && !item.fields && !item.type_kintone) {
                            item.data = JSON.parse(JSON.stringify(this.listViews[n].data));
                            item.fields = JSON.parse(JSON.stringify(this.listViews[n].fields));
                            item.type_kintone = JSON.parse(JSON.stringify(this.listViews[n].type_kintone));
                        }
                    }
                    let listFields = this.listViews[n].fields;
                    let arrFieldResult = [
                        {
                            label: this.$t('filter.allRecord'),
                            code: 'All_Record',
                            type: ''
                        }
                    ];
                    if (listFields) {
                        Object.keys(listFields).map((key) => {
                            let obj = {
                                label: listFields[key].label,
                                code: listFields[key].code,
                                type: listFields[key].type
                            };
                            arrFieldResult.push(obj);
                        });
                    }
                    this.listFilters = arrFieldResult.filter((elm) => elm.type !== TYPE_SUB_TABLE);
                }

                if (this.dataView.view_id) {
                    let i = this.listViews.findIndex((x) => x.id === this.dataView.view_id.toString());
                    if (i >= 0) {
                        const viewCurrent = Object.assign({}, this.listViews[i]);
                        this.dataView.view_name = viewCurrent.name;
                        this.dataPreviews = viewCurrent;
                        this.dataPreviews.data = [].concat(viewCurrent.data.records);
                    }
                } else if (this.dataView.view_id === '') {
                } else {
                    let i = this.listViews.findIndex((x) => x.id === null);
                    if (i >= 0) {
                        const viewCurrent = this.listViews[i];
                        this.dataView.view_name = viewCurrent.name;
                        this.dataPreviews = viewCurrent;
                        this.dataPreviews.data = [].concat(viewCurrent.data.records);
                    }
                }
                this.options = [].concat(this.listViews);
                this.isLoading = false;
                this.isAddCondition = false;
            };
            let errorCallback = () => {
                this.isLoading = false;
            };
            let spaceId = this.dataView.workspace_id;
            if (this.dataView.workspace_id === null) {
                spaceId = '';
            }
            let payload = {
                appId: this.dataView.app_id,
                space_id: spaceId,
                queryString: query,
                successCallback,
                errorCallback
            };
            this.$store.dispatch('connect/getListViews', payload);
        },
        onGetQueryString() {
            let query = '';
            let { filterContents, conditionType } = this;
            let queryContents = this.$ld.filter(filterContents, (elm) => elm.field && elm.field !== this.TYPE_ALL_RECORD);
            if (queryContents && queryContents.length > 0) {
                query = 'filterCond=';
                this.$ld.map(queryContents, (elm, index) => {
                    let typeValue = typeof elm.value;
                    if (typeValue === 'string' || typeValue === 'number') {
                        let itemQuery = `${elm.field} ${elm.type} "${elm.value}"`;
                        query += itemQuery;
                    } else if (typeValue === 'array' || typeValue === 'object') {
                        if (elm.value && elm.value.length > 0) {
                            let itemQuery = `${elm.field} ${elm.type} (`;
                            this.$ld.map(elm.value, (elmValue, indexValue) => {
                                itemQuery += `"${elmValue}"`;
                                if (indexValue < elm.value.length - 1) {
                                    itemQuery += ',';
                                }
                            });
                            itemQuery += ')';
                            query += itemQuery;
                        }
                    }
                    if (index < queryContents.length - 1) {
                        if (conditionType === 1) {
                            query += ' and ';
                        } else {
                            query += ' or ';
                        }
                    }
                });
            }
            return query;
        },
        onSearchDataView() {
            let { filterContents, conditionType } = this;
            let query = '';
            let queryContents = filterContents.filter((elm) => elm.field && elm.field !== this.TYPE_ALL_RECORD);
            this.dataView.arrayContentFilter = queryContents ?? [];
            if (!queryContents || queryContents.length === 0) {
                this.getListViews();
                return;
            }
            query = 'filterCond=';
            queryContents.forEach((elm, index) => {
                let typeValue = typeof elm.value;
                if (typeValue === 'string' || typeValue === 'number') {
                    let itemQuery = `${elm.field} ${elm.type} "${elm.value}"`;
                    query += itemQuery;
                } else if (typeValue === 'array' || typeValue === 'object') {
                    if (elm.value && elm.value.length > 0) {
                        let itemQuery = `${elm.field} ${elm.type} (`;
                        this.$ld.map(elm.value, (elmValue, indexValue) => {
                            itemQuery += `"${elmValue}"`;
                            if (indexValue < elm.value.length - 1) {
                                itemQuery += ',';
                            }
                        });
                        itemQuery += ')';
                        query += itemQuery;
                    }
                }
                if (index < queryContents.length - 1) {
                    query += conditionType === 1 ? ' and ' : ' or ';
                }
            });
            this.getListViews(query);
        },
        showKintoneView(id) {
            indexKintoneView(id, this.userInfo, this.dataView);
        },
        emitAppData(o) {
            if (o.type === 'LIST' || o.type === 'CALENDAR') {
                let dataSet = this.$ld.assign({}, o);
                this.dataPreviews = dataSet;
                this.dataPreviews.data = [].concat(dataSet.data?.records ?? dataSet.data);
                this.dataView.view_id = o.id;
                this.dataView.view_name = o.name;
                this.dataView.arrayFieldView = null;
                this.dataView.arrayFieldDisabled = null;
                this.dataView.fieldDisplayLayout = null;
            }
        }
    }
};
</script>
